import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import {
    authLinks,
    creatorMenu,
    myStuffMenu,
    myStuffApiMenu,
    myAccountMenu,
    adminMenu
} from "../../data/links";

import { Section, Grid, Row, Col, H1 } from "../shared";
import { colors } from "../shared/colors";
import {
    Wrapper,
    Header,
    ContainedGrid,
    HeaderContent,
    CloseIcon,
    ItemHeading,
    Item,
    Items,
    Teams,
    LogOutButton,
    ArrowLeftIcon,
    MobileSpacing
} from "./styles";

let ProfileMenuMobile = ({ user, closeMenu, logOut, className }) => {
    user = user || {};
    user.ownedTeams = user.ownedTeams || {};

    const getLinks = ({ linkData }) =>
        linkData.map(link => (
            <Item
                key={link.name}
                onClick={closeMenu}
                href={
                    typeof link.href === "string"
                        ? link.href
                        : link.href({ username: user.username })
                }
                target={link.external ? "_blank" : "_self"}
            >
                {typeof link.name === "string"
                    ? link.name
                    : link.name({ hasNotifications: user.hasNotifications })}
            </Item>
        ));

    const creatorMenuLinks = getLinks({ linkData: creatorMenu });
    const myStuffMenuLinks = getLinks({ linkData: myStuffMenu });
    const myStuffApiMenuLinks = getLinks({ linkData: myStuffApiMenu });
    const myAccountMenuLinks = getLinks({ linkData: myAccountMenu });
    const adminMenuLinks = getLinks({ linkData: adminMenu });

    return (
        <Wrapper className={className}>
            <Header>
                <ContainedGrid>
                    <HeaderContent
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <ArrowLeftIcon
                            fillColor={colors.brownishGreyTwo}
                            onClick={closeMenu}
                        />
                        <H1 size={16} bold>
                            Profile
                        </H1>
                        <CloseIcon
                            onClick={closeMenu}
                            fillColor={colors.brownishGreyTwo}
                        />
                    </HeaderContent>
                </ContainedGrid>
            </Header>
            {user.isCreator && (
                <>
                    <ItemHeading>Creator</ItemHeading>
                    <Items>{creatorMenuLinks}</Items>
                </>
            )}
            <ItemHeading>My Stuff</ItemHeading>
            <Items>
                {myStuffMenuLinks}
                {user.hasApiKey && <>{myStuffApiMenuLinks}</>}
            </Items>
            <ItemHeading>My Account</ItemHeading>
            <Items>
                {myAccountMenuLinks}
                {!!user.ownedTeams.length && (
                    <Item noLink>
                        Manage Team:
                        <Teams teams={user.ownedTeams} />
                    </Item>
                )}
            </Items>
            {user.isSuperuser && (
                <>
                    <ItemHeading>Admin</ItemHeading>
                    <Items>{adminMenuLinks}</Items>
                </>
            )}
            <Section>
                <Grid>
                    <Row center="sm">
                        <Col sm={12} md={3}>
                            <LogOutButton size="medium" onClick={logOut}>
                                {authLinks.logout.text}
                            </LogOutButton>
                        </Col>
                    </Row>
                </Grid>
            </Section>

            <MobileSpacing />
        </Wrapper>
    );
};

ProfileMenuMobile = styled(ProfileMenuMobile)``;

ProfileMenuMobile.propTypes = {
    user: PropTypes.object,
    closeMenu: PropTypes.func,
    logout: PropTypes.func
};

export { ProfileMenuMobile };
